import { Accordion, Badge, Flex, Text, useMantineTheme } from "@mantine/core";
import { GetCreditAllotmentManyQuery } from "src/generated/graphql";
import { ClientCardBg } from "src/utils/constants";

interface ClientOverProps {
  creditsData: GetCreditAllotmentManyQuery["creditAllotmentMany"];
}

const Credits = ({ creditsData }: ClientOverProps) => {
  const theme = useMantineTheme();

  return (
    <Flex direction={"column"}>
      <Text size={18} fw={600} color={theme.colors.secondaryTextColor[6]}>
        My Credits
      </Text>

      <Accordion
        styles={{
          item: {
            background: theme.colors.primary[6],
            color: theme.colors.primaryTextColor[6],
            marginTop: "15px",
            borderRadius: "10px",
            border: "0px",
          },
          control: {
            "&:active": {
              backgroundColor: "rgba(0,0,0,0)",
            },
          },
          chevron: {
            margin: "0px",
          },
        }}
        style={{ borderRadius: 4 }}
      >
        {creditsData &&
          creditsData.map((credit) => {
            return (
              <Accordion.Item value={credit.id} key={credit.id}>
                <Accordion.Control
                  style={{ color: theme.colors.primaryTextColor[6] }}
                >
                  <Flex justify={"space-between"} align={"center"}>
                    <Flex direction={"column"}>
                      <Text
                        size={14}
                        fw={600}
                        color={theme.colors.primaryTextColor[6]}
                      >
                        {credit.name}
                      </Text>
                      <Text
                        size={14}
                        fw={600}
                        color={theme.colors.primaryTextColor[6]}
                      >
                        {`${credit.count} Available`}
                      </Text>
                    </Flex>
                    <Flex direction={"column"}>
                      <Text
                        size={12}
                        fw={500}
                        color={theme.colors.primaryTextColor[6]}
                      >
                        {credit.agreement && credit.agreement?.name}
                        {credit.package && credit.package?.name}
                      </Text>
                      <Text
                        size={12}
                        fw={500}
                        color={theme.colors.primaryTextColor[6]}
                      >
                        {credit.expiresAt
                          ? new Date(credit.expiresAt).toLocaleDateString()
                          : "No Expiration"}
                      </Text>
                    </Flex>
                  </Flex>
                </Accordion.Control>
                <Accordion.Panel>
                  {credit.services.map((service, index) => {
                    return (
                      <Badge
                        color="secondary"
                        variant="filled"
                        mx={5}
                        key={index}
                      >
                        {service.name}
                      </Badge>
                    );
                  })}
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}
      </Accordion>
    </Flex>
  );
};

export default Credits;
